module.exports = __webpack_public_path__ + "img/Res_Busbf_kl.82deb4bd.jpg";